export default __webpack_public_path__ + "img/kl_goodvibes-1df41594f936a67a1dc2be04007bf787.png";